module.exports = {
  "account_page": null,
  "shopping_cart_page": null,
  "not_found_page": null
}